/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React, { createRef, useEffect, useState } from "react";

// Mui components
import Grid from "@mui/material/Grid2";

// Store
import { useDispatch, useSelector } from "react-redux";
import {
  // setLoading,
  clearErrors,
  deleteAttraction,
  updateAttraction,
  deleteSingleAttraction,
} from "store/actions/attractionActions";
import setAlert from "store/actions/alertActions";

// Custom components
import DashboardLayout from "layouts/DashboardLayout";
import Footer from "components/Footer";
import DashboardNavbar from "components/DashboardNavbar";
import MaterialTablePicker from "components/MaterialTablePicker";
import { getUserPartnerLocations, setLoading, setLocation } from "store/actions/locationAction";
import LocationUserPartner from "components/locations/LocationUserPartner";
import columnsMap from "components/MaterialTablePicker/TableColumns";
import { getPdf, getCsv } from "store/actions/exportAction";
import form from "../new-attraction/schemas/form";
import AttractionDestinationEditComponent from "./components/AttractionDestinationEditComponent";

const Attractions = () => {
  const { location } = form.formField;

  const dispatch = useDispatch();
  const tableRef = createRef();

  const loading = useSelector((state) => state.attractions.loading);
  const error = useSelector((state) => state.attractions.error);
  const user = useSelector((state) => state.users.user);
  // const attraction = useSelector((state) => state.attractions.attraction);
  const locationAtt = useSelector((state) => state.locations.location);
  const added = useSelector((state) => state.attractions.added);

  const [onChangeLocationID, setOnChangeLocationID] = useState(false);
  const [locationId, setLocationId] = useState(
    user?.locations?.length > 0 ? user?.locations[0]?._id : null
  );

  const deleteAttractionFn = (id) => {
    dispatch(deleteAttraction(id));
  };

  const updateAttractionFn = (data) => {
    const updatedData = { _id: data._id, title: data.title, city: data.city };
    if (data.destinations && data.destinations.value) {
      updatedData.destination = data.destinations.value;
    } else if (data.destinations && data.destinations._id) {
      updatedData.destination = data.destinations._id;
    } else if (typeof data.destinations === "string") {
      updatedData.destination = data.destinations;
    } else if (data.destinations === null || typeof data.destinations === "undefined") {
      updatedData.destination = "";
    }
    dispatch(updateAttraction(updatedData));
  };
  const handleChange = (option, val) => {
    if (locationAtt) dispatch(deleteSingleAttraction());

    setOnChangeLocationID(true);
    if (val?._id) {
      setLocationId(val?._id);
      dispatch(setLocation(val._id));
      tableRef.current?.onQueryChange();
    }
  };

  useEffect(() => {
    if (user?.role === "partner") {
      dispatch(setLoading());
      dispatch(getUserPartnerLocations());
    }
  }, []);

  useEffect(() => {
    if (user?.locations?.length > 0 && locationAtt === null) {
      setLocationId(user?.locations[0]?._id);
    }
    // eslint-disable-next-line
  }, [user?.locations]);

  useEffect(() => {
    if (error) {
      dispatch(setAlert(error, "error"));
      dispatch(clearErrors());
    }
  }, [error, setAlert]);

  // to add use Effect for set locaton ID
  useEffect(() => {
    if (locationAtt && locationId !== locationAtt) {
      setLocationId(locationAtt);
      dispatch(setLocation(locationAtt));
    }
  }, [locationAtt, locationId]);

  // Defining custom columns for the attractions table
  const attractionSpecificColumns = [
    columnsMap.titleCol,
    {
      ...columnsMap.destinations,
      editComponent: (props) => (
        <AttractionDestinationEditComponent
          {...props}
          formSchemaField={form.formField.destination}
        />
      ),
    },
    columnsMap.retailPrice,
    columnsMap.travelDeskName,
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={3}>
        <Grid size={{ xs: 4 }}>
          {user?.role === "partner" && user?.locations.length > 0 && (
            <LocationUserPartner
              defaultLocationId={locationId}
              handleChange={handleChange}
              locations={user?.locations || {}}
              location={location}
            />
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          {((user.role === "partner" && locationId) || user.role === "admin") && (
            <MaterialTablePicker
              key={locationId || added}
              screen="AttractionsList"
              title="Attractions"
              tableRef={tableRef}
              columns={attractionSpecificColumns} // Use the custom columns
              asyncTable
              asyncURL={
                user.role === "admin"
                  ? `${process.env.REACT_APP_API}/attractions?`
                  : onChangeLocationID
                  ? `/v2/locations/${locationId}/attractions?`
                  : locationAtt && locationAtt !== locationId
                  ? `/v2/locations/${locationAtt}/attractions?`
                  : `/v2/locations/${locationId}/attractions?`
              }
              isLoading={loading}
              searchField="attractionsList"
              exportMenuField="attractionsList"
              onRowClickURL={`/${user.role}/attractions`}
              currentUrl="attractions"
              addUrl="attractions/new-attraction"
              actionsName="attraction"
              actionsRole={user.role === "admin"}
              editableUpdate={updateAttractionFn}
              editableDelete={deleteAttractionFn}
              updateRoleAction
              deleteRoleAction
              editableRole={user.role === "admin"}
              getPdf={(value, query) => {
                if (value) {
                  if (user?.role === "partner") {
                    dispatch(
                      getPdf(
                        value,
                        `stats/pdf${query}&fields=title,destinations,retail_price.formatted_iso_value,travelDesk`,
                        "Attractions"
                      )
                    );
                  } else {
                    dispatch(
                      getPdf(
                        value,
                        `stats/pdf${query}&fields=title,destinations,retail_price.formatted_iso_value,travelDesk`,
                        "Attractions"
                      )
                    );
                  }
                } else {
                  // Handle the case where 'value' is undefined or empty
                  console.error("Error: No data for PDF export.");
                }
              }}
              getCsv={(query) => {
                if (user?.role === "partner") {
                  dispatch(
                    getCsv(
                      `stats/csv${query}&fields=title,destinations,retail_price.formatted_iso_value,travelDesk`,
                      "Attractions",
                      `${locationId}`
                    )
                  );
                } else if (user?.role === "admin") {
                  dispatch(
                    getCsv(
                      `stats/csv${query}&fields=title,destinations,retail_price.formatted_iso_value,travelDesk`,
                      "Attractions"
                    )
                  );
                } else {
                  // Handle the case where 'value' is undefined or empty
                  console.error("Error: No data for CSV export.");
                }
              }}
            />
          )}
        </Grid>
      </Grid>
      <Footer />
    </DashboardLayout>
  );
};

export default Attractions;
